import { Action } from '@ngrx/store';
import { Order } from '@cemex-core/cmx-api';

export enum OrderActionTypes {
  LOAD_PLANT_DATE_TIME = '[Modify Order] Load plant date time',
  SET_PLANT_DATE_TIME = '[Modify Order] Set plant date time',
  SET_ORDER = '[Modify Order] Set order',
  SET_ORDER_ID = '[Modify Order] Set order id',
  REQUEST = '[Modify Order] Request',
  REQUEST_COMPLETE = '[Modify Order] Request complete',
  REQUEST_OP = '[Modify Order OP] Request',
  REQUEST_OP_COMPLETE = '[Modify Order OP] Request complete',
  REQUEST_UNIFIED = '[Modify Order Unified] Request',
  REQUEST_UNIFIED_COMPLETE = '[Modify Order Unified] Request complete',
  SET_QUANTITY_MODIFY = '[Modify Order] Set quantity',
  RESET = '[Modify Order] Reset',
}

export class LoadPlantDateTimeAction implements Action {
  readonly type = OrderActionTypes.LOAD_PLANT_DATE_TIME;

  constructor(public payload: Order) {}
}
export class SetPlantDateTimeAction implements Action {
  readonly type = OrderActionTypes.SET_PLANT_DATE_TIME;

  constructor(public payload: string) {}
}
export class SetOrderCodeAction implements Action {
  readonly type = OrderActionTypes.SET_ORDER;

  constructor(public payload: string) {}
}

export class SetOrderIdAction implements Action {
  readonly type = OrderActionTypes.SET_ORDER_ID;

  constructor(public payload: number) {}
}

export class OrderLoadAction implements Action {
  readonly type = OrderActionTypes.REQUEST;

  constructor() {}
}

export class OrderLoadUpdateAction implements Action {
  readonly type = OrderActionTypes.REQUEST_OP;

  constructor() {}
}

export class OrderLoadUnifiedAction implements Action {
  readonly type = OrderActionTypes.REQUEST_UNIFIED;

  constructor() {}
}

export class OrderLoadUnifiedCompleteAction implements Action {
  readonly type = OrderActionTypes.REQUEST_UNIFIED_COMPLETE;

  constructor(public payload: any) {}
}

export class OrderLoadCompleteAction implements Action {
  readonly type = OrderActionTypes.REQUEST_COMPLETE;

  constructor(public payload: any) {}
}

export class OrderLoadCompleteActionOP implements Action {
  readonly type = OrderActionTypes.REQUEST_OP_COMPLETE;

  constructor(public payload: any) {}
}

export class SetQuantityModifyAction implements Action {
  readonly type = OrderActionTypes.SET_QUANTITY_MODIFY;

  constructor(public payload: number) {}
}

export class OrderResetAction implements Action {
  readonly type = OrderActionTypes.RESET;

  constructor() {}
}

export type OrderActions =
  | LoadPlantDateTimeAction
  | SetPlantDateTimeAction
  | SetOrderCodeAction
  | OrderLoadAction
  | OrderLoadCompleteAction
  | SetQuantityModifyAction
  | OrderLoadUpdateAction
  | OrderLoadCompleteActionOP
  | SetOrderIdAction
  | OrderLoadUnifiedAction
  | OrderLoadUnifiedCompleteAction
  | OrderResetAction;
